import api from './api';

const connectoriprangesService = {
  getAllConnectorIPRanges: async (filters = {}) => {
    try {
      const params = new URLSearchParams();
      if (filters.connectorid) params.append('connectorid', filters.connectorid);
      if (filters.accountid) params.append('accountid', filters.accountid);

      const response = await api.get(`/admin/connectoripranges?${params.toString()}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching connector IP ranges:', error);
      throw error;
    }
  },

  getConnectorIPRangeById: async (id) => {
    try {
      const response = await api.get(`/admin/connectoripranges/${id}`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching connector IP range ${id}:`, error);
      throw error;
    }
  },

  createConnectorIPRange: async (ipRangeData) => {
    try {
      const cleanedData = Object.fromEntries(
        Object.entries(ipRangeData).map(([key, value]) => [
          key,
          value === '' ? null : value
        ])
      );

      const response = await api.post('/admin/connectoripranges', cleanedData);
      return response.data;
    } catch (error) {
      console.error('Error creating connector IP range:', error);
      throw error;
    }
  },

  updateConnectorIPRange: async (id, ipRangeData) => {
    try {
      const cleanedData = Object.fromEntries(
        Object.entries(ipRangeData).map(([key, value]) => [
          key,
          value === '' ? null : value
        ])
      );

      const response = await api.put(`/admin/connectoripranges/${id}`, cleanedData);
      return response.data;
    } catch (error) {
      console.error(`Error updating connector IP range ${id}:`, error);
      throw error;
    }
  },

  deleteConnectorIPRange: async (id) => {
    try {
      const response = await api.delete(`/admin/connectoripranges/${id}`);
      return response.data;
    } catch (error) {
      console.error(`Error deleting connector IP range ${id}:`, error);
      throw error;
    }
  }
};

export default connectoriprangesService;
